import AxiosService from '@/Services/AxiosService';
import LoaderService from '@/Services/LoaderService';
import { Inject, Service } from 'vue-di-container';
import FileSaver from 'file-saver';
import { ComplaintDetailsGetDetailsResponse } from './ComplaintDetails/ComplaintDetailsModel';
import { EditComplaintDetailsModel } from './ComplaintDetails/EditComplaintDetailsModel';
import { FilterModel } from './FilterModel';
@Service()
export default class SenderComplaintsService {
    @Inject(AxiosService) public axiosService!: AxiosService;
    @Inject(LoaderService) public loaderService!: LoaderService;

    public async Get(model: any): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/complaint';
            const result = await this.axiosService.axiosInstance.get(url, {
                params: model,
            });
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }

    public async ExportSenderComplaintReport(filter: FilterModel): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/complaint/export-sender-complaint-report';
            const result = await this.axiosService.axiosInstance.get(url, {
                params: {
                    senderName: filter.senderName || '',
                    complaintId: filter.complaintId || '',
                    clientName: filter.clientName || '',
                    providerName: filter.providerName || '',
                    complaintStatus: filter.complaintStatus || 0,
                    dateFrom: filter.dateFrom || '',
                    dateTo: filter.dateTo || '',
                },
            });
            this.loaderService.HideLoader();
            if (result.data.isSuccess) {
                const array = Buffer.from(result.data.result, 'base64');
                const blob = new Blob([array], { type: 'application/vnd.ms-excel' });
                FileSaver.saveAs(blob, 'Sender Complaint Report.xlsx');
                return result.data;
            }
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }

    public async Reactivate(model: string[]): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/complaint/reactivate';
            const result = await this.axiosService.axiosInstance.put(url, model);
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }
    public async closeComplaint(id: string): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/complaint/close-complaint';
            const model = {
                id : id
            };
            const result = await this.axiosService.axiosInstance.put(url, model);
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }
    public async deactivateComplaint(id: string): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/complaint/deactivate-complaint';
            const model = {
                id: id
            };
            const result = await this.axiosService.axiosInstance.put(url, model);
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }
    public async GetDetails(id: string): Promise<ComplaintDetailsGetDetailsResponse | false> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/complaint/get-details/' + id;
            const result = await this.axiosService.axiosInstance.get(url);
            this.loaderService.HideLoader();
            return result.data as ComplaintDetailsGetDetailsResponse;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }
    public async EditComplaint(model: EditComplaintDetailsModel): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/complaint/edit-complaint';
            const result = await this.axiosService.axiosInstance.post(url, model);
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }
    public async GetFileContent(id: string): Promise<string> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/complaint/attachments/' + id;
            const result = await this.axiosService.axiosInstance.get(url);
            this.loaderService.HideLoader();
            return result.data.result;
        } catch (exception) {
            this.loaderService.HideLoader();
            return '';
        }
    }
}
